/* eslint-disable array-callback-return */
const prepareForOptions = (data, labelField, valueField) => {
  if (!data) {
    return [];
  }


  return data.map((item) => ({
    label: Array.isArray(labelField) ? labelField.map((field) => item[field]).join(' - ') : item[labelField],
    value: item[valueField],
    escritorioVendaId: item.escritorioVendaId || null,

  }));
};

export default prepareForOptions;
